export var FILE_STORAGE_V2_REPOSITORY = 'FILE_STORAGE_V2_REPOSITORY';